import { getApplicationList } from "@/api/apiclient/application";
import type { applicationType } from "@/types/application";
import { defineStore } from "pinia";

export const useContext = defineStore("context", {
  state: () => {
    return {
      list: [] as Array<applicationType>,
      availableApplications: [] as Array<applicationType>,
    };
  },
  actions: {
    async loadApplicationList() {
      try {
        const res = await getApplicationList();
        if (res && res.length > 0) {
          this.list = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    getInfoFromId(state) {
      return (id: number | null): applicationType | null => {
        return state.list.find((i) => i.id == id) ?? null;
      };
    },
    getNameFromId(state) {
      return (id: number | null): string => {
        return state.list.find((i) => i.id == id)?.name ?? "";
      };
    },
    getLogoFromId(state) {
      return (id: number | null): string | null => {
        return state.list.find((i) => i.id == id)?.logo ?? null;
      };
    },
  },
});
